import {_} from 'lodash';
import {IRouteDefinition, TRefKey, TRouteId} from "../index";
import {_d, getObjectDefinition} from "./misc";
import {ObjectTypeId} from "../constants";
import {getRouteDefinition} from "../constants/RouteDefinitions";
import {TServiceName} from "../constants/ApiServices";

export namespace nsReference {

    export interface IReferenceDefinition {
        api?: TServiceName | null
        group?: TRefKey | null
        icon?: string | null
        name: string
        key: TRefKey
        routeId?: TRouteId | null
    }

    export type TReferenceDefinitions = {
        [K in TRefKey]?: Partial<IReferenceDefinition>
    }

    const refDefinition: TReferenceDefinitions = {
        'jcompany': {
            routeId: 'customerconfig',
            name: 'company',
        },
        'jcompanysyncstep': {
            routeId: 'syncstatusv2',
            name: 'company syncstep',
        },
        'jexportflow': {
            api: 'searchexporttemplate',
            group: 'jexporttemplate',
            routeId: 'synctemplatedetails',
            name: 'synchronization flow',
        },
        'jexporttemplate': {
            api: 'getexporttemplate',
            routeId: 'synctemplatedetails',
            name: 'synchronization template',
        },
        'jformtemplate': {
            api: 'getehubprocess',
            routeId: 'formtemplatedetails',
            name: 'form template',
        },
        'jmanualobject': {
            key: 'jmanualobject',
            name: 'manual object', // depends on type
        },
        'jmessage': {
            api: 'getmessage',
            routeId: 'messageflowdetails',
            name: 'message flow',
        },
        'jobject': {
            api: 'getobject',
            name: 'object', // depends on type
        },
        'jruleset': {
            api: 'getruleset',
            routeId: 'rulesetdetails',
            name: 'ruleset',
        },
        'jsystem': {
            api: 'searchsystem',
            routeId: 'systemaccessdetails',
            name: 'collection',
        },
        'jsystemrole': {
            api: 'searchsystem',
            group: 'jsystem',
            icon: 'fa-id-card-alt',
            routeId: 'systemaccessdetails',
            name: 'permission',
        },
    };

    export function getReferenceDefinition(key: TRefKey): IReferenceDefinition {
        let ret = refDefinition[key];
        if (!ret) {
            _d.warn('No such reference object', key);
            return {
                api: null,
                group: null,
                icon: 'fa-question',
                key,
                name: 'unknown',
                routeId: null,
            }
        }
        switch (key) {
            case 'jobject':
            case 'jmanualobject':
                return _.defaults(ret, {
                    api: 'getobject',
                    group: null,
                    icon: null,
                    key,
                    name: 'object',
                    routeId: ret.routeId,
                })
        }
        const routeDef = ret.routeId ? getRouteDefinition(ret.routeId) : null
        return _.defaults(ret, {
            api: null,
            group: null,
            icon: routeDef?.icon ?? null,
            key,
            name: routeDef?.label ?? ret.name,
            routeId: ret.routeId ?? null,
        })
    }

    export function getObjectReferenceDefinition(key: TRefKey, objectTypeId: ObjectTypeId, manual: boolean): IReferenceDefinition {
        const objDef = getObjectDefinition(objectTypeId);
        if (!objDef) {
            return {
                api: 'getobject',
                group: key,
                icon: null,
                key: key,
                name: manual ? 'manual object': 'object',
                routeId: null,
            }
        }
        return {
            api: 'getobject',
            group: key,
            icon: manual ? objDef.iconManual: objDef.icon,
            key: key,
            name: manual ? 'manual object': 'object',
            routeId: objDef.routeDetails ?? null,
        }
    }

}
